module.exports = __webpack_public_path__ + "media/ad_preview/fb_likes-24ed13df.png";